import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from 'src/games/LandscapingGame/scenes/GameIntro';

interface PhaserLandscapeGameProps {
    onComplete?: () => void;
}

interface PhaserLandscapeGameState {
}

const gameConfig: GameConfig = {
    title: "Landscaping Game",
    version: "0.9.3",
    physics: {
        default: 'arcade',
        arcade: {
            debug: false,
            gravity: { y: 0 }
        }
    },
    backgroundColor: "#d3d3d3"
};

class PhaserLandscapeGame extends React.Component<PhaserLandscapeGameProps, PhaserLandscapeGameState> {
    constructor(props: PhaserLandscapeGameProps) {
        super(props);
        bindAllOfThis(this, PhaserLandscapeGame.prototype);
    }

    render() {
        return <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />;
    }
}

export default PhaserLandscapeGame;



// WEBPACK FOOTER //
// ./src/games/LandscapingGame/Main.tsx